import { post as apiPost } from "./API";

export async function reserveAuthenticated(data: any): Promise<any> {
  return apiPost(`reservations`, data, { requiresAuth: true });
}

export async function reserveUnauthenticated(data: any): Promise<any> {
  return apiPost(`reservations/unauthenticated`, data);
}
